(function () {
  function initMobileDrilldown(menu) {
    if (!menu || menu.dataset.drilldownReady === "true") return;

    menu.dataset.drilldownReady = "true";

    function getPanels() {
      return Array.prototype.slice.call(
        menu.querySelectorAll("[data-drilldown-panel]")
      );
    }

    function getPanel(panelName) {
      return menu.querySelector(
        '[data-drilldown-panel="' + panelName + '"]'
      );
    }

    function getActivePanel() {
      return menu.querySelector(
        "[data-drilldown-panel].is-active"
      );
    }

    function showPanel(panelName) {
      var targetPanel = getPanel(panelName);
      var currentPanel = getActivePanel();

      if (!targetPanel) {
        console.warn("Panneau introuvable :", panelName);
        return;
      }

      if (currentPanel && currentPanel !== targetPanel) {
        currentPanel.classList.remove("is-active");
        currentPanel.classList.add("is-previous");
        currentPanel.setAttribute("aria-hidden", "true");
      }

      targetPanel.classList.remove("is-previous");
      targetPanel.classList.add("is-active");
      targetPanel.setAttribute("aria-hidden", "false");
      targetPanel.scrollTop = 0;
    }

    function goBack() {
      var currentPanel = getActivePanel();

      if (!currentPanel) return;

      var parentPanelName =
        currentPanel.getAttribute("data-drilldown-parent") || "root";

      var parentPanel = getPanel(parentPanelName);

      if (!parentPanel) {
        parentPanel = getPanel("root");
      }

      currentPanel.classList.remove("is-active");
      currentPanel.setAttribute("aria-hidden", "true");

      parentPanel.classList.remove("is-previous");
      parentPanel.classList.add("is-active");
      parentPanel.setAttribute("aria-hidden", "false");
      parentPanel.scrollTop = 0;
    }

    function resetMenu() {
      var panels = getPanels();

      panels.forEach(function (panel) {
        panel.classList.remove("is-active", "is-previous");
        panel.setAttribute("aria-hidden", "true");
      });

      var rootPanel = getPanel("root") || panels[0];

      if (rootPanel) {
        rootPanel.classList.add("is-active");
        rootPanel.setAttribute("aria-hidden", "false");
        rootPanel.scrollTop = 0;
      }
    }

    menu.addEventListener(
      "click",
      function (event) {
        var openButton = event.target.closest("[data-drilldown-open]");

        if (openButton && menu.contains(openButton)) {
          event.preventDefault();
          event.stopPropagation();

          var panelName = openButton.getAttribute("data-drilldown-open");
          showPanel(panelName);

          return;
        }

        var backButton = event.target.closest("[data-drilldown-back]");

        if (backButton && menu.contains(backButton)) {
          event.preventDefault();
          event.stopPropagation();

          goBack();
        }
      },
      true
    );

    var drawer = menu.closest("#NavDrawer");

    if (drawer) {
      drawer
        .querySelectorAll(".js-drawer-close")
        .forEach(function (closeButton) {
          closeButton.addEventListener("click", function () {
            window.setTimeout(resetMenu, 300);
          });
        });
    }

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape") {
        window.setTimeout(resetMenu, 300);
      }
    });

    resetMenu();
  }

  function initAllMobileDrilldowns() {
    document
      .querySelectorAll("[data-mobile-drilldown]")
      .forEach(initMobileDrilldown);
  }

  document.addEventListener("DOMContentLoaded", initAllMobileDrilldowns);
  document.addEventListener("shopify:section:load", initAllMobileDrilldowns);
  window.addEventListener("load", initAllMobileDrilldowns);
})();